import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaskedInput from 'react-text-mask';
import { AcnColorTheme } from '../../assets/css/AcnColorTheme';
import DynamicTitle from '../../component/DynamicTitle';
import TemplateComponent from '../../component/template/TemplateComponent';
import { UserManageVerifyRequest } from '../../models/RequestModel';
import { UserInfoModel } from '../../models/UserInfoModel';
import { RootState } from '../../store';
import { actions as UserAction } from '../../store/redux/UserInfoRedux';
import { actions as VerificationAction } from '../../store/redux/UserVerificationRedux';
import { NavTo } from '../../utils/AppManager';
import { mobileNumberMask, Path } from '../../utils/Constant';
import { defaultHeight, fontUnit, heightUnit, padGinUnit } from '../../utils/DeviceManager';
import { isMobileNumber } from '../../utils/SecureManager';
const iOS = require('is-ios');

export function MobileNumberForManageScreen(props: any) {
  const dispatch = useDispatch();
  const [userInfo, screen] = useSelector((state: RootState) => [
    state.userInfoReducer.userInfo,
    state.deviceReducer.screenView,
  ]);

  const [error, setError] = useState(false);
  const [mobile, setMobile] = useState('');
  const [message, setMessage] = useState('');
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const [isFetching, setIsFetching] = useState(false);

  const NOT_FOUND =
    'ไม่พบข้อมูลในระบบ กรุณาตรวจสอบหมายเลขแล้วลองอีกครั้ง หรือติดต่อ Call Center โทร. 02-777-7333 เพื่ออัปเดตหมายเลขโทรศัพท์มือถือ';
  const MAINTENANCE = 'ขณะนี้เรากำลังปรับปรุงระบบ ขออภัยในความไม่สะดวก กรุณาลองใหม่ในภายหลัง';

  const isValidMobile = () => {
    return isMobileNumber(mobile);
  };

  useEffect(() => {
    document.title = 'สมัครใช้งาน\u200E\u200E\u200E\u200E\u200E\u200E\u200E';
  }, []);

  const verify = async (request: UserManageVerifyRequest) => {
    setIsFetching(true);
    setMaintenanceMessage('');
    setMessage('');
    try {
      const response = await VerificationAction.postVerification(dispatch, request);
      if (!!response.accessToken) {
        setError(false);
        NavTo(Path.mng_vrf, 'verification-success');
      } else {
        setError(true);
        setMessage(NOT_FOUND);
      }
    } catch (error: any) {
      // Failed CORS preflight and timeouts have no HTTP response in Axios.
      const status = error?.response?.status;
      const blockedUntil: string = error?.response?.data?.unblockTime;
      const accessToken: string = error?.response?.data?.accessToken ?? request.token;
      if (status === 400 && blockedUntil && accessToken) {
        // A cooldown response contains no new token. Keep the existing manage token.
        await VerificationAction.setVerification(dispatch, {
          accessToken: accessToken,
          unblockTime: blockedUntil,
        });
        NavTo(Path.mng_vrf);
      } else if (typeof status === 'number' && status < 500) {
        setError(true);
        setMessage(NOT_FOUND);
      } else {
        setMaintenanceMessage(MAINTENANCE);
      }
    } finally {
      setIsFetching(false);
    }
  };

  const onConfirm = async () => {
    if (props?.match?.params?.token) {
      const token = props.match.params.token;
      if (isValidMobile()) {
        const newInfo: UserInfoModel = { ...userInfo, mobile: mobile, accessToken: token };
        UserAction.setUserInfo(dispatch, newInfo).then(() => {
          const request: UserManageVerifyRequest = {
            recipientPhoneNumber: mobile,
            token: token,
          };
          verify(request);
        });
      }
    } else {
      setMessage(
        'ขออภัยในความไม่สะดวก โทเค็นไม่ถูกต้อง กรุณาลองใหม่ในอีกสักครู่ หรือติดต่อฝ่ายบริการลูกค้าที่หมายเลข 02-777-7333',
      );
    }
  };

  const onLoading = () => {
    return (
      <Typography
        component="div"
        align={'center'}
        style={{
          position: 'relative',
          width: '100%',
          alignContent: 'center',
          paddingTop: padGinUnit(200),
        }}
      >
        <CircularProgress color="primary" style={{ alignSelf: 'center' }} />
      </Typography>
    );
  };

  const mobileNumberWidget = () => {
    return (
      <div style={{ position: 'fixed', overflow: 'hidden', marginRight: '20px' }}>
        <div style={{ height: heightUnit(defaultHeight * 0.82), overflowY: 'auto', overflowX: 'hidden' }}>
          <DynamicTitle title={'กรุณากรอกหมายเลขโทรศัพท์มือถือ'} isFull={true} align={'left'} size={fontUnit(24)} />
          {maintenanceMessage && (
            <Typography
              align={'left'}
              style={{
                width: '95%',
                color: AcnColorTheme.secondaryRed,
                fontFamily: 'Prompt-Medium',
                fontSize: fontUnit(16),
                marginTop: padGinUnit(8),
              }}
            >
              {maintenanceMessage}
            </Typography>
          )}
          <Typography align={'left'} style={{ color: AcnColorTheme.black }}>
            <MaskedInput
              mask={mobileNumberMask}
              guide={false}
              value={mobile}
              onChange={({ currentTarget }) => {
                const value = currentTarget.value.replaceAll('-', '');
                setMobile(value);
                if (isMobileNumber(value)) {
                  setMaintenanceMessage('');
                  setMessage('');
                }
              }}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  onConfirm();
                }
              }}
              style={{
                width: '93%',
                height: heightUnit(56),
                minHeight: 42,
                colorAdjust: 'inherit',
                marginTop: padGinUnit(40),
                outline: 'none',
                paddingLeft: padGinUnit(8),
                fontSize: fontUnit(18),
                fontWeight: 'normal',
                borderRadius: 8,
                borderWidth: error ? 2 : 0,
                borderColor: error ? AcnColorTheme.secondaryRed : 'black',
                fontFamily: 'Prompt-Medium',
              }}
              id="mobilenumber"
              type="tel"
              name="mobilenumber"
              placeholder="หมายเลขโทรศัพท์มือถือ"
              autoComplete="off"
              title="เบอร์โทรศัพท์"
              aria-labelledby="InputLabel"
              aria-required="false"
              autoFocus
              required
            />
          </Typography>
          <Typography
            align={'left'}
            style={{
              width: '95%',
              color: AcnColorTheme.secondaryRed,
              padding: padGinUnit(8),
              fontSize: fontUnit(16),
              marginTop: padGinUnit(8),
            }}
          >
            {message}
          </Typography>
          <div style={{ height: !iOS ? '250px' : '' }} />
        </div>
      </div>
    );
  };

  return (
    <TemplateComponent
      content={isFetching ? onLoading() : mobileNumberWidget()}
      onNext={onConfirm}
      isCanNext={isValidMobile() && !isFetching}
      nextText={'ยืนยัน'}
    />
  );
}
